/**
 * Tell HTML bootstrap watchdogs that this root finished bootstrapping
 * (mounted or showed a handled failure). Prevents false "App did not load"
 * when in-app spinners share .nm-loading-spinner.
 */
export function markRootBooted(el) {
  if (!el || typeof el.setAttribute !== "function") return;
  el.setAttribute("data-nm-booted", "1");
  try {
    if (typeof window !== "undefined" && window.__nmBootWatchdog != null) {
      clearTimeout(window.__nmBootWatchdog);
      window.__nmBootWatchdog = null;
    }
  } catch (_) {}
}
